var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "#3be07b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.5 -14.089)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(15.5 15.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.5,29.3l2.359,3.021,4.714-5.038",
    transform: "translate(-3.73 -6.526)"
  }))));
};
export default SvgCheckCircle;